import { render, staticRenderFns } from "./test1.vue?vue&type=template&id=57f156af&scoped=true&"
import script from "./test1.vue?vue&type=script&lang=js&"
export * from "./test1.vue?vue&type=script&lang=js&"
import style0 from "./test1.vue?vue&type=style&index=0&id=57f156af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f156af",
  null
  
)

export default component.exports